<app-loader-component *ngIf="setLoadingState"></app-loader-component>
<div class="bar-chart" *ngIf="!setLoadingState && !_isAnnual">
   <app-income-statement-chart [chartKey]="chartKey"></app-income-statement-chart>
</div>
<div class="bar-chart" *ngIf="!setLoadingState && _isAnnual">
   <app-income-statement-annual-chart [chartKey]="chartKey"></app-income-statement-annual-chart>
</div>
<ul class="annual_quater_tab" *ngIf="!setLoadingState">
   <!-- <li [class.active]="_isAnnual" (click)="changePeriod(true)">
     <i class="icon-annual"></i> Annual
  </li>
  <li [class.active]="!_isAnnual" (click)="changePeriod(false)">
     <i class="icon-quaterly"></i> Quarterly
  </li> -->

   <li [class.active]="_isAnnual" (click)="changePeriod(true)">
      <img [src]="_isAnnual ? 'assets/icons/annual-green.svg' : 'assets/icons/annual-grey.svg'" alt="Annual Icon">
      Annual
   </li>

   <li [class.active]="!_isAnnual" (click)="changePeriod(false)">
      <img [src]="!_isAnnual ? 'assets/icons/quaterly-green.svg' : 'assets/icons/quaterly-grey.svg'"
         alt="Quarterly Icon">
      Quarterly
   </li>
</ul>

<div class="" *ngIf="!setLoadingState">
   <app-income-statement-table [_isAnnual]="_isAnnual" [data]="annualData"
      [quarterlydata]="quarterlyData"></app-income-statement-table>
</div>
